import React, { useState, useEffect } from "react";
import {
  FaInstagram,
  FaXTwitter,
  FaLinkedin,
  FaTiktok,
  FaEnvelope,
  FaXmark,
  FaCopy,
} from "react-icons/fa6";
import logo from "../../assets/images/header-logo.png";
import "./ShareButton.css";

const ShareButton = ({ link, forceOpen = false, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);

  const encodedMsg = encodeURIComponent("Check out this kitchen: " + link);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(link);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("ShareButton-overlay")) {
      handleClose();
    }
  };

  useEffect(() => {
    if (forceOpen) {
      setIsOpen(true);
    }
  }, [forceOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return isOpen ? (
    <div className="ShareButton-overlay" onClick={handleOverlayClick}>
      <div className="ShareButton-popup">
        <div className="ShareButton-header">
          <img src={logo} alt="Airkitchenz Logo" className="ShareButton-logo" />
          <FaXmark className="ShareButton-close-icon" onClick={handleClose} />
        </div>

        <div className="ShareButton-icons">
          <a
            href={`https://www.instagram.com/direct/new/?text=${encodedMsg}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href={`https://twitter.com/messages/compose?text=${encodedMsg}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on Twitter DM"
          >
            <FaXTwitter />
          </a>
          <a
            href={`https://www.linkedin.com/messaging/compose?body=${encodedMsg}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href={`https://www.tiktok.com/share?url=${encodeURIComponent(link)}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share on TikTok"
          >
            <FaTiktok />
          </a>
          <a
            href={`mailto:?subject=Check out this kitchen&body=${encodedMsg}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Share via Email"
          >
            <FaEnvelope />
          </a>
        </div>

        <span className="ShareButton-or-divider">OR</span>

        <div className="ShareButton-copy-container">
          <input type="text" value={link} readOnly className="ShareButton-copy-input" />
          <button className="ShareButton-copy-button" onClick={handleCopyLink}>
            <FaCopy />
            {copySuccess ? "Copied!" : "Copy Link"}
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default ShareButton;
